import MediaLibrarySearchLink from './media-library/search-link';

class CheckoutConfirmation
{
    constructor()
    {
        // Imports
        this.mediaLibrarySearchLink = new MediaLibrarySearchLink;

        // ELements
        this.mlSearchlinkElement = document.querySelector('.js-media-library__search-link');
        this.mlSearchNoteElement = document.querySelector('.js-media-library__search-note');
    }

    init()
    {
        this.mediaLibrarySearchLink.init(this.mlSearchlinkElement, this.mlSearchNoteElement);
    }
}

if (document.querySelector('#checkout-confirmation'))
{
    const checkoutConfirmation = new CheckoutConfirmation();

    checkoutConfirmation.init();
}
